export default __webpack_public_path__ + "static/media/iud-ec@2x.5a336d30.jpg";